
function nearFilter(btn){
    if(!navigator.geolocation)  return;

    var getLocation = function(){
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    var search = btn.search;
                    var coords = 'long='+position.coords.longitude+'&lat='+position.coords.latitude;
                    btn.search = search ? search + '&' + coords : '?' + coords;
                    document.location = btn.href;
                },
                () => {
                    alert('Геолокацию не удалось получить. Список ближайших кинотеатров может быть неточным. Разрешите браузеру определять местоположение для нашего сайта.');
                    document.location = btn.href;
                },
                {
                    timeout: 5000
                }
            );
        };

    btn.addEventListener('click', function(e){
        e.preventDefault();
        getLocation();
    }, false);
}

export {nearFilter};